import { createSelector } from '@reduxjs/toolkit';

import { AnnotationTemplateWithoutContents } from '@paragon/contract-library';

import { RootState } from '../slices';

const hasOptions = (templates: readonly AnnotationTemplateWithoutContents[] | null) =>
  templates ? templates.length > 1 : false;

export const hasTrussDesignDrawingTemplateOptionsSelector = createSelector(
  [(state: RootState) => state.annotationTemplates.trussDesignDrawingTemplates],
  (trussDesignDrawingTemplates) => hasOptions(trussDesignDrawingTemplates),
);

export const hasTrussDesignDrawingOverflowTemplateOptionsSelector = createSelector(
  [(state: RootState) => state.annotationTemplates.trussDesignDrawingOverflowTemplates],
  (trussDesignDrawingOverflowTemplates) => hasOptions(trussDesignDrawingOverflowTemplates),
);

export const hasRepairTrussDesignDrawingTemplateOptionsSelector = createSelector(
  [(state: RootState) => state.annotationTemplates.repairTrussDesignDrawingTemplates],
  (repairTrussDesignDrawingTemplates) => hasOptions(repairTrussDesignDrawingTemplates),
);

export const needsToMakeTrussDesignDrawingTemplateSelectionsSelector = createSelector(
  [hasTrussDesignDrawingTemplateOptionsSelector, hasTrussDesignDrawingOverflowTemplateOptionsSelector],
  (hasTrussDesignDrawingOptions, hasTrussDesignDrawingOverflowOptions) =>
    hasTrussDesignDrawingOptions || hasTrussDesignDrawingOverflowOptions,
);
